<template>
  <div class="tags-list-container">
    <div class="tags-list" :class="{ elevated }">
      <TagsManagerListItem
        v-for="tag in tags"
        :tag="tag"
        :key="tag.id"
        :light="elevated"
        :add-enabled="addEnabled"
        :edit-enabled="editEnabled"
        :remove-enabled="removeEnabled"
        :max-characters="15"
        managable
        :auto-categorization-settings="autoCategorizationSettings"
        :show-auto-categorization-icon="showAutoCategorizationIcon"
        :show-sentiment-selector="showSentimentSelector"
        @edit="onEdit"
        @remove="onRemove"
        @change-auto="changeAuto"
      />
    </div>
  </div>
</template>

<script>
import TagsManagerListItem from "@/components/Tags/TagsManagerListItem";

export default {
  name: "TagsManagerList",
  components: {
    TagsManagerListItem
  },
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    showSentimentSelector: {
      type: Boolean,
      default: true
    },
    addEnabled: {
      type: Boolean,
      default: false
    },
    editEnabled: {
      type: Boolean,
      default: false
    },
    removeEnabled: {
      type: Boolean,
      default: false
    },

    elevated: {
      type: Boolean,
      default: false
    },
    featureEnabled: {
      type: Boolean,
      default: false
    },
    showAutoCategorizationIcon: {
      type: Boolean,
      default: false
    },
    autoCategorizationSettings: {
      type: Object
    }
  },
  methods: {
    onAdd(tag) {
      this.$emit("add", tag);
    },

    onEdit(tag) {
      this.$emit("edit", tag);
    },

    onRemove(tag) {
      this.$emit("remove", tag);
    },
    changeAuto(tag) {
      this.$emit("change-auto", tag);
    }
  }
};
</script>

<style lang="scss" scoped>
.tags-list-container {
  margin: -10px;
}

.tags-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px;
}

.elevated {
  filter: drop-shadow(0px 0px 6px rgba(54, 60, 86, 0.07));
}
</style>
